import {curveLinear} from 'd3';

import TimeSeriesProvider from 'src/components/TimeSeriesProvider';
import TimeSeriesViz, {
  SOLO_VIZ_HEIGHT,
  SOLO_VIZ_HEIGHT_WITH_LEGEND,
} from 'src/components/TimeSeriesViz';
import Viz from 'src/components/Viz';
import {
  VizConfigCreatorItem,
  makeConfigItems,
  makeRequestFromVizConfig,
} from 'src/components/Viz/config';
import WithWidth from 'src/components/WithWidth';
import {SeriesType, Site} from 'src/lib/api/project';
import {
  AllColumns,
  FLOW_OBSERVATION_SOURCES,
  FlowHistoricalDailyColumns,
  Source,
} from 'src/lib/api/series';
import COLORS from 'src/lib/colors';
import * as tw from 'src/lib/tailwindClasses';

export default function FlowGauge({
  site,
  dateRange,
  setDateRange,
}: {
  site: Site;
  dateRange: [Date, Date];
  setDateRange: (dateRange: [Date, Date]) => void;
}) {
  const config = {
    observations: makeConfigItems(
      'observations',
      [
        {
          displayName: 'Historical mean flow',
          source: Source.FLOW_HISTORICAL_DAILY,
          columns: [FlowHistoricalDailyColumns.FLOW_MEAN],
          getStyle: () => ({stroke: COLORS.OBS, strokeDasharray: 2}),
          legendIcon: 'line',
          curveFactory: curveLinear,
        },
        ...site.observationTimeSeries[SeriesType.GaugeFlow]
          .filter(
            (q) => FLOW_OBSERVATION_SOURCES.includes(q.source) && q.columns && q.columns.length
          )
          .flatMap((q): VizConfigCreatorItem => {
            return {
              displayName: q.source,
              source: q.source,
              columns: [q.columns![0]] as AllColumns[],
              getStyle: () => ({
                stroke: COLORS.OBS,
                strokeOpacity: 1,
              }),
              legendIcon: 'line',
              curveFactory: curveLinear,
            };
          }),
      ],
      {}
    ),
    forecasts: [],
  };

  return (
    <WithWidth>
      {(width) => (
        <div className={tw.sectionBody}>
          <TimeSeriesProvider
            site={site}
            dateRange={dateRange}
            forecastTimesBySource={{}}
            {...makeRequestFromVizConfig(config)}
          >
            {(vizProps) => {
              return (
                <Viz
                  section="Gauge observations"
                  title="Flow"
                  site={site}
                  loadingStateDims={[width, SOLO_VIZ_HEIGHT_WITH_LEGEND]}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  config={config}
                  {...vizProps}
                >
                  {(props) => (
                    <TimeSeriesViz
                      {...props}
                      timeZone={site.localTimeZone}
                      dims={[width, SOLO_VIZ_HEIGHT]}
                    />
                  )}
                </Viz>
              );
            }}
          </TimeSeriesProvider>
        </div>
      )}
    </WithWidth>
  );
}
